import { Cell, Gutter, IconDelete, IconEdit } from '@adserve/adserve-react-components';
import React, { useContext, useState, useEffect } from 'react';
import { SystemSettingsContext } from '../../../contexts/SystemSettingsContext';
import { sumBillingPlanLines } from './BespokeBillingUtils';
import moment from 'moment';

const BespokeInvoiceListRow = ({
    index,
    invoice,
    onEditInvoice,
    onDeleteInvoice,
    calcVatRate,
    scrollPx,
    onScroll,
    scrollableLength,
    rowHeight,
    visibleRows,
    disabled
}) => {
    const { formatCurrency, dateFormat } = useContext(SystemSettingsContext);
    const [invoiced, setInvoiced] = useState(false);

    useEffect(() => {
        if (invoice?.billingPlanInvoiceLines?.length > 0) {
            const invoicedLines = invoice?.billingPlanInvoiceLines?.filter((bpil) => bpil.invoiceRunId !== null);
            setInvoiced(invoicedLines && invoicedLines?.length > 0);
        } else {
            setInvoiced(false);
        }
    }, [invoice]);

    const onEditClick = () => {
        onEditInvoice(invoice);
    };

    const onDeleteClick = () => {
        onDeleteInvoice(invoice);
    };

    const calcTotals = () => {
        if (typeof calcVatRate !== 'function') {
            return {
                invoiceTotal: 0,
                vatTotal: 0,
                commissionTotal: 0
            };
        }
        let invoiceTotal = 0;
        let vatTotal = 0;
        let commissionTotal = 0;
        invoice?.billingPlanInvoiceLines?.forEach((il) => {
            const amount = parseFloat(il.airtimeAmount) + parseFloat(il.offAirAmount);
            const commission = (amount * il.commissionRate) / 100;
            const amountLessCommission = amount - commission;
            const vat = amountLessCommission * il.vatRate / 100;

            invoiceTotal += amount;
            vatTotal += vat;
            commissionTotal += commission;
        });
        return {
            invoiceTotal,
            vatTotal,
            commissionTotal
        };
    };

    const invoiceTotals = calcTotals();
    const maxVisibleLength = rowHeight * visibleRows;

    // ASSP-6309 Narrative on Bespoke Billing Screen
    var narrative = '';
    if (invoice?.billingPlanInvoiceLines) {
        if (invoice.name) {
            narrative = invoice.name;
        } else if (invoice.billingPlanInvoiceLines.length) {
            narrative = invoice.billingPlanInvoiceLines[0].name;
        }
    }

    return (
        <>
            <Cell
                align='center'
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
                style={{ borderLeftWidth: 1 }}
            >
                {'id' in invoice && (
                    <IconEdit
                        onClick={onEditClick}
                        height={21}
                        width={21}
                        style={{
                            margin: '0px 0px 0px 0px',
                            padding: 0
                        }}
                        disabled={invoiced || disabled}
                    />
                )}
            </Cell>
            <Cell
                align='center'
                rowHeight={rowHeight}
                visibleRows={visibleRows}
                scrollPx={scrollPx}
                index={index}
            >
                {'id' in invoice && (
                    <IconDelete onClick={onDeleteClick} height={21} width={21} disabled={disabled || invoiced} />
                )}
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                <div style={{ width: '100%', textAlign: 'left', verticalAlign: 'middle' }}>{narrative}</div>
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {invoice?.invoiceDate && moment(invoice?.invoiceDate).utc(true).startOf('day').format(dateFormat) }
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {invoice?.poNumber}
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {sumBillingPlanLines(invoice, 'airtimeAmount') + sumBillingPlanLines(invoice, 'offAirAmount') > 0 && 
                    formatCurrency(sumBillingPlanLines(invoice, 'airtimeAmount') + sumBillingPlanLines(invoice, 'offAirAmount'))}
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {invoiceTotals.commissionTotal > 0 && formatCurrency(invoiceTotals.commissionTotal)}
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {sumBillingPlanLines(invoice, 'netAmount') > 0 &&
                    formatCurrency(sumBillingPlanLines(invoice, 'netAmount'))}
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {invoiceTotals.vatTotal > 0 && formatCurrency(invoiceTotals.vatTotal)}
            </Cell>
            <Cell rowHeight={rowHeight} visibleRows={visibleRows} scrollPx={scrollPx} index={index} style={{fontWeight: 'normal'}}>
                {invoiceTotals.invoiceTotal > 0 &&
                    formatCurrency(
                        sumBillingPlanLines(invoice, 'airtimeAmount') +
                        sumBillingPlanLines(invoice, 'offAirAmount') +
                            invoiceTotals.vatTotal -
                            invoiceTotals.commissionTotal
                    )}
            </Cell>
            {index === 0 && (
                <Gutter
                    rowHeight={rowHeight}
                    visibleRows={visibleRows}
                    scrollPx={scrollPx}
                    index={index}
                    maxVisibleLength={maxVisibleLength}
                    scrollableLength={scrollableLength}
                    onScroll={onScroll}
                ></Gutter>
            )}

            {index >= visibleRows && <div></div>}
        </>
    );
};

export default BespokeInvoiceListRow;
